import React, { Component } from "react";

export default class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      valid: null,
    };

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.cleared !== prevProps.cleared) {
      this.setState({
        checked: false,
      });
    }
  };

  handleChange = (event) => {
    this.setState({ checked: !this.state.checked });
  };

  toggle = (event) => {
    event.preventDefault();
    this.setState(function (state, props) {
      return {
        checked: !state.checked,
      };
    });
  };

  render() {
    const { name, required } = this.props;
    return (
      <div className="cb_Container">
        <input
          required={required}
          type="checkbox"
          name={name}
          id={name}
          checked={this.state.checked}
          onChange={this.handleChange}
        />
        <button
          onClick={this.toggle}
          className={`checkBox ${this.props.imgsrc && "checkBox-image"} ${
            this.state.checked
              ? "checked"
              : this.state.valid === null
              ? ""
              : "notChecked"
          }`}
        >
          <div className="icon">
            <div className="icon--content">&#10004;</div>
          </div>
          <div className="checkBox--text">{this.props.children}</div>
        </button>
      </div>
    );
  }
}
